<template>
  <div class="exception-component">
    <FluidContainer>
      <span class="exception-component--message">{{ exception.Message }}</span>
    </FluidContainer>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import FluidContainer from '@/components/FluidContainer'

@Component({
  components: {
    FluidContainer,
  },
  props: {
    exception: {
      type: Object,
      required: false,
    },
  },
})
export default class ExceptionComponent extends Vue {

}
</script>

<style lang="scss">
.exception-component {
  margin: 10px 0;

  &--message {
    padding: 20px;
    border: 1px solid rgba(231, 31, 108, .5);
    background-color: rgba(231, 31, 108, .3);
    color: #545454;
    font-size: 1em;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Exception.vue